const STATE = {
  LIVE: 'creator.viddsee.com',
  STAGING: 'blueberry.viddsee.com',
  TEST: 'strawberry.viddsee.com',
  LOCAL: 'localhost',
};

const STATE_VARIABLE = {
  [STATE.LIVE]: {
    BASE_URL: 'https://www.viddsee.com',
    API_URL: 'https://www.viddsee.com/v1/',
    AWS_FOLDER: 'submissions',
  },
  [STATE.STAGING]: {
    BASE_URL: 'http://blueberry.viddsee.com',
    API_URL: 'http://blueberry.viddsee.com/v1/',
    AWS_FOLDER: 'submissions',
  },
  [STATE.TEST]: {
    BASE_URL: 'https://strawberry.viddsee.com',
    API_URL: 'https://strawberry.viddsee.com/v1/',
    AWS_FOLDER: 'dev_submissions',
  },
  [STATE.LOCAL]: {
    BASE_URL: 'http://localhost:3000',
    API_URL: 'https://strawberry.viddsee.com/v1/',
    AWS_FOLDER: 'dev_submissions',
  },
};

// Set Application Current State if its host matches the given STATE,
// otherwise, set it to Test State
const currentState = (STATE_VARIABLE[window.location.hostname])
  ? window.location.hostname
  : STATE.TEST;

const AWS = {
  UPLOAD_ENDPOINT: 'https://viddsee.s3.amazonaws.com',
  KEY: 'AKIAIZM3RQRE5XANYRAA',
  BUCKET: 'viddsee',
  SIGNER_URL: `${STATE_VARIABLE[currentState].API_URL}/submitvideo/upload_signature`,
  UPLOAD_FOLDER: STATE_VARIABLE[currentState].AWS_FOLDER,
};

export default {
  ...STATE_VARIABLE[currentState],
  AWS,
  Survey: {
    ENDPOINT: 'https://0soms4dmv9.execute-api.ap-southeast-1.amazonaws.com/prod/survey',
  },
};



// WEBPACK FOOTER //
// ./src/config/variables.js